module.exports = __webpack_public_path__ + "media/images/alumni/header-a8aedbd90bedfe05b127792acbd9d490.jpg";